var exports = {
  "kL": "x52a3aa3b--2ddd50--container",
  "dL": "x52a3aa3b--2ddd50--static",
  "Ki": "x52a3aa3b--2ddd50--video",
};

module.exports = exports;
